import IndicatorsHistoryModel from "../models/indicatorsHistory";
import { encryptApiKey } from "../helpers/apiToken";
import IndicatorsModel from "../models/indicatorsModel";
import { backHost } from "../params";
 
export default class IndicatorsService {

  static getIndicators(): Promise<IndicatorsModel[]> {
    const apiKeyEncrypt = encryptApiKey();
    return fetch(backHost+'/indicators', {
        method: 'GET',
        headers: { 'apiKey': apiKeyEncrypt}
      })
      .then(response => response.json())
      .catch(error => {
        console.error('Erreur API Indicators : ', error.message);
      });
  }
 
  static getIndicator(uid: number): Promise<IndicatorsModel|null> {
    const apiKeyEncrypt = encryptApiKey();
    return fetch(backHost+`/indicators/${uid}`, {
        method: 'GET',
        headers: { 'apiKey': apiKeyEncrypt}
      })
      .then(response => response.json())
      .then(data => this.isEmpty(data) ? null : data);
  }

  static getIndicatorHistory(uid: number): Promise<IndicatorsHistoryModel[]|null> {
    //console.log("IndicatorsHistoryService ", backHost);
    const apiKeyEncrypt = encryptApiKey();
    return fetch(backHost+`/history/${uid}`, {
        method: 'GET',
        headers: { 'apiKey': apiKeyEncrypt}
      })
      .then(response => response.json())
      .then(data => this.isEmpty(data) ? null : data);
  }
 
  static isEmpty(data: Object): boolean {
    return Object.keys(data).length === 0;
  }
}